import React from 'react'

import { Col, Row, Portlet, Form, Button } from '_zari/core'

import * as FacturacionService from 'services/facturacion.service'

import { DownloadAxiosFile } from 'utils'

import { ZariContext } from '_zari/context'

import * as FormGroups from './formGroups'

import { DateHandler } from 'utils'

const VentasReportes = ({ history }) => {
  const [fechaHasta, setFechaHasta] = React.useState(new Date())
  const [flagSoloCerrado, setFlagSoloCerrado] = React.useState(false)
  const [_idSocio, setIdSocio] = React.useState('')
  const [nombreSocio, setNombreSocio] = React.useState('')

  const [usuarios, setUsuarios] = React.useState([])
  const [usuarioSeleccionado, setUsuarioSeleccionado] = React.useState('')
  const [sedes, setSedes] = React.useState([])
  const [sedeSeleccionada, setSedeSeleccionada] = React.useState([])
  const [clienteSeleccionado, setClienteSeleccionado] = React.useState(null)
  const [turnos, setTurnos] = React.useState([])
  const [turnoSeleccionado, setTurnoSeleccionado] = React.useState('')
  const [fechaDesde, setFechaDesde] = React.useState(new Date())
  const [fechaHasta2, setFechaHasta2] = React.useState(new Date())
  const [flagResumen, setFlagResumen] = React.useState(false)
  const [flagMinimo, setFlagMinimo] = React.useState(false)

  const __zariContext = React.useContext(ZariContext)

  React.useEffect(() => {
    const fecha = new Date()
    const mes = fecha.getMonth()
    const anio = fecha.getFullYear()
    const primerDiaMes = new Date(anio, mes, 1)
    setFechaDesde(DateHandler.format(primerDiaMes))
    setFechaHasta2(DateHandler.format(fecha))
  }, [])

  const clickDescargarReporte = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte saldo de guías...')
    FacturacionService.descargarReporteVentas({
      fechaHasta,
      flagSoloCerrado,
      _idSocio
    })
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [fechaHasta, flagSoloCerrado, _idSocio, __zariContext])

  const clickDescargarReporteVentas = React.useCallback(() => {
    const idSocio = clienteSeleccionado ? clienteSeleccionado._id : null
    __zariContext.loader.open('Descargando reporte de ventas...')
    if (flagResumen) {
      FacturacionService.descargarReporteVentasRepResumen({
        fechaDesde,
        fechaHasta2,
        turnoSeleccionado,
        usuarioSeleccionado,
        sedeSeleccionada,
        idSocio
      })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    } else if (flagMinimo) {
      FacturacionService.descargarReporteVentasRepMinimo({
        fechaDesde,
        fechaHasta2,
        turnoSeleccionado,
        usuarioSeleccionado,
        sedeSeleccionada,
        idSocio
      })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    } else {
      FacturacionService.descargarReporteVentasRep({
        fechaDesde,
        fechaHasta2,
        turnoSeleccionado,
        usuarioSeleccionado,
        sedeSeleccionada,
        idSocio
      })
        .then(({ data, headers }) => {
          DownloadAxiosFile.downloadAsBlob(data, headers)
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          __zariContext.loader.close()
        })
    }
  }, [
    turnoSeleccionado,
    flagResumen,
    flagMinimo,
    fechaDesde,
    fechaHasta2,
    usuarioSeleccionado,
    sedeSeleccionada,
    clienteSeleccionado,
    __zariContext
  ])

  return (
    <>
      <Row>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='Saldo De Guías' />
            <Portlet.Body>
              <Row>
                <Col md={6}>
                  <FormGroups.SocioFormGroup
                    iValue={_idSocio}
                    vNombreSocio={nombreSocio}
                    setIdSocio={setIdSocio}
                    setNombreSocio={setNombreSocio}
                  />
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label text='Hasta' htmlFor='Hasta' md={4} />
                    <Col md={6}>
                      <Form.InputDate
                        value={fechaHasta}
                        name='fechaHasta'
                        id='date-hasta'
                        onChange={e => {
                          setFechaHasta(e.target.value)
                        }}
                      />
                    </Col>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Group>
                    <Col md={4}>
                      <Form.Checkbox
                        id='checkbox-soloCerrado'
                        name='checkbox-soloCerrado'
                        label='Solo Cerrado'
                        checked={flagSoloCerrado}
                        onChange={() => setFlagSoloCerrado(prev => !prev)}
                      />
                    </Col>
                  </Form.Group>
                </Col>
                <Col md={6} className='text-right'>
                  <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </Col>
        <Col md={6}>
          <Portlet>
            <Portlet.Header title='Reporte De Ventas' />
            <Portlet.Body>
              <Row>
                <Col md={6}>
                  <FormGroups.FechaFormGroup
                    value={fechaDesde}
                    name='fechaDesde'
                    id='date-desde'
                    text='Desde'
                    onChange={e => setFechaDesde(e.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <FormGroups.FechaFormGroup
                    value={fechaHasta2}
                    name='fechaHasta2'
                    id='date-hasta2'
                    onChange={e => setFechaHasta2(e.target.value)}
                    text='Hasta'
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroups.UsuarioFormGroup
                    usuarios={usuarios}
                    setUsuarios={setUsuarios}
                    usuarioSeleccionado={usuarioSeleccionado}
                    setUsuarioSeleccionado={setUsuarioSeleccionado}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroups.SedeFormGroup
                    sedes={sedes}
                    setSedes={setSedes}
                    sedeSeleccionada={sedeSeleccionada}
                    setSedeSeleccionada={setSedeSeleccionada}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroups.ClienteFormGroup
                    clienteSeleccionado={clienteSeleccionado}
                    setClienteSeleccionado={setClienteSeleccionado}
                  />
                </Col>
              </Row>
              <Row className='mb-2'>
                <Col md={12}>
                  <FormGroups.TurnoFormGroup
                    turnos={turnos}
                    setTurnos={setTurnos}
                    turnoSeleccionado={turnoSeleccionado}
                    setTurnoSeleccionado={setTurnoSeleccionado}
                    usuarioSeleccionado={usuarioSeleccionado}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroups.FlagResumenFormGroup
                    text='Resumen'
                    value={flagResumen}
                    handleChange={() => {
                      setFlagResumen(prev => !prev)
                      setFlagMinimo(false)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <FormGroups.FlagMinimoFormGroup
                    text='Minimo'
                    value={flagMinimo}
                    handleChange={() => {
                      setFlagMinimo(prev => !prev)
                      setFlagResumen(false)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12} className='text-right'>
                  <Button onClick={clickDescargarReporteVentas}>Descargar Reporte</Button>
                </Col>
              </Row>
            </Portlet.Body>
          </Portlet>
        </Col>
      </Row>
    </>
  )
}

export default VentasReportes
